// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3ldb1","inputDescription":"styles_inputDescription__3PqOe"};